import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { buildWaLinkGeneric, WA_NUMBER_LOCAL } from "../lib/whatsapp";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  const waLink = buildWaLinkGeneric(
    "Halo, saya ingin konsultasi motor Yamaha. Mohon info stok & promo terbaru area Kalimantan Barat."
  );

  const scrollTo = (id) => {
    setOpen(false);
    if (!isHome) return;
    if (id === "top") { window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const NAV = [
    { label: "Beranda", id: "top" },
    { label: "Terpopuler", id: "terpopuler" },
    { label: "Katalog", id: "katalog" },
    { label: "Kredit", id: "kredit" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200"
    >
      <div className="y-container flex items-center justify-between gap-2 h-14 sm:h-16">
        <Link
          to="/"
          data-testid="nav-brand"
          className="flex items-center gap-1.5 sm:gap-2 font-display font-black shrink-0"
        >
          <span className="inline-flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-[#002d62] text-white text-sm sm:text-base">
            Y
          </span>
          <span className="text-sm sm:text-base leading-tight text-[#002d62]">
            Yamaha<span className="text-[#e60012]">Kalbar</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {isHome && NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#002d62] transition-colors"
            >
              {item.label}
            </button>
          ))}
          {!isHome && (
            <Link to="/" className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#002d62]">
              ← Kembali
            </Link>
          )}
        </nav>

        {/* Right side: WA CTA (always visible) + mobile menu toggle */}
        <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
          <a
            data-testid="nav-wa-cta"
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full bg-[#25D366] text-white text-[11px] sm:text-sm font-semibold hover:bg-[#1ebe57] transition-colors whitespace-nowrap"
          >
            <MessageCircle className="w-3.5 h-3.5 shrink-0" />
            <span>{WA_NUMBER_LOCAL}</span>
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-1.5 rounded-lg border border-slate-200"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>

      {open && isHome && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-slate-200 bg-white">
          <div className="y-container py-2 flex flex-col">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                data-testid={`nav-mobile-${item.id}`}
                className="text-left px-3 py-2.5 rounded-lg hover:bg-slate-50 text-slate-800 text-sm font-medium"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
